import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { swalMessages } from '@auteco/constants';
import swal from 'sweetalert';
import { Context } from '../../context/Contex';
import {
  getChannels, postChannel, putChannel, deleteChannel,
} from '../../services/channelServices';
import ChannelsPage from '../../pages/MaestrosPage/ChannelsPage/ChannelsPage';

const ChannelsContainer = () => {
  const [open, setOpen] = useState(false);
  const [channels, setChannels] = useState([]);
  const [form, setForm] = useState({ channel: '' });

  const history = useHistory();
  const { unidad } = useContext(Context);

  const fetchChannels = async (unityId) => {
    const { success, data } = await getChannels(unityId);
    if (success) {
      setChannels(data);
    } else {
      swal(swalMessages.GENERAL_ERROR);
    }
  };
  const onSubmitForm = async (event) => {
    event.preventDefault();
    const { success, id } = await postChannel({
      canal: form.channel,
      unidad_id: unidad,
    });
    if (success) {
      setChannels([...channels, { id, unidad_id: unidad, canal: form.channel }]);
      swal(swalMessages.SUCCESSFUL_MESSAGE);
    } else {
      swal(swalMessages.GENERAL_ERROR);
    }
  };

  const onUpdateChannel = async ({ newData }) => {
    const { success } = await putChannel({
      canal: newData.canal,
      id: newData.id,
    });
    if (success) {
      const updatedChannels = channels.map((channel) => {
        if (channel.id === newData.id) {
          return {
            ...channel,
            canal: newData.canal,
          };
        }
        return channel;
      });
      setChannels(updatedChannels);
    } else {
      swal(swalMessages.GENERAL_ERROR);
    }
  };

  const onDeleteChannel = (rowData) => {
    swal(swalMessages.DELETE_CONFIRM).then(async (willDelete) => {
      if (willDelete) {
        const { success } = await deleteChannel(rowData.id);
        if (success) {
          const updateChannels = channels.filter((item) => item.id !== rowData.id);
          setChannels(updateChannels);
          swal(swalMessages.SUCCEFUL_DELETE);
        } else {
          swal(swalMessages.GENERAL_ERROR);
        }
      }
    });
  };
  const redirectToHome = (unityId) => {
    if (unityId === '2' || unityId === '6') {
      fetchChannels(unityId);
    } else {
      swal(swalMessages.NOT_AVAILABLE).then(() => {
        history.push('/home');
      });
    }
  };

  const onChangeInput = (value, field) => {
    setForm({ ...form, [field]: value });
  };

  const openForm = () => {
    setOpen(!open);
  };

  useEffect(() => {
    redirectToHome(unidad);
  }, []);

  return (
    <ChannelsPage
      open={open}
      openForm={openForm}
      channels={channels}
      onSubmitForm={onSubmitForm}
      onChangeInput={onChangeInput}
      onUpdateChannel={onUpdateChannel}
      onDeleteChannel={onDeleteChannel}
    />
  );
};

export default ChannelsContainer;
